import React from "react";

import { categoryData } from "./Data";
import CategoryCard from "./CategoryCard";
import classes from "./Category.module.css";
function Category() {
  return (
    <div className={classes.card_container}>
      {categoryData.map((info) => {
        return <CategoryCard data={info} key={info.id} />;
      })}
    </div>
  );
}

export default Category;
